<template>
  <div>
    <span
      v-if="label"
      class="label"
    >{{ label }}<sup v-if="required">*</sup></span>
    <ul
      :class="[
        'rs-checkbox-group',
        {
          'list-col-1': columns == 1,
          'list-col-2': columns == 2,
          'list-col-3': columns == 3,
          'list-col-4': columns == 4,
        },
      ]
      "
    >
      <li
        v-for="(option, i) in options"
        :key="i"
      >
        <RsFormCheckbox
          :id="`${id}_${i}`"
          v-model="selectedCheckboxes"
          :disabled="option.disabled || disabled"
          :name="`checkbox_group`"
          :value="option.value"
          :label="option.text"
          @change="$emit('checked', option.value); $emit('change', selectedCheckboxes);"
        />
      </li>
    </ul>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';
import { ISelectOption } from '@/shared';

export default defineComponent({
  name: 'RsCheckboxGroup',

  props: {
    id: {
      type: String,
      required: true,
    },
    required: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: '',
    },
    options: {
      type: Array as PropType<ISelectOption[]>,
      default: () => [],
    },
    columns: {
      type: Number,
      default: null,
    },
    selected: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      selectedCheckboxes: this.selected || [],
    };
  },
  watch: {
    selected() {
      this.selectedCheckboxes = this.selected || [];
    },
  },
});
</script>

<style lang="scss" scoped>
  @import '@/styles/_variables.scss';
  .rs-checkbox-group{
    list-style-type: none;
    margin: 0;
    display: flex;
    flex-wrap: wrap;
    &.list-col-1{
      li{
        width: 100%;
      }
    }
    &.list-col-2{
     li{
        width: calc(50% - 0.5rem);
      }
    }
    &.list-col-3{
      li{
        width: calc(33.3% - 0.5rem);
      }
    }
    &.list-col-4{
      li{
        width: calc(25% - 0.5rem);
      }
    }
    &.stacked{
      li{
        width: 100%;
        display: flex;
      }
    }
  }
</style>
